var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.709 25.418C19.7279 25.418 25.4179 19.728 25.4179 12.709C25.4179 5.69003 19.7279 0 12.709 0C5.68997 0 0 5.69003 0 12.709C0 19.728 5.68997 25.418 12.709 25.418Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68079 12.709H18.737",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.709 6.68091V18.7373",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.418,
    height: 25.418,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGray);
export default __webpack_public_path__ + "static/media/icon_add_gray.1bfb6c12a9636ed7a0c989f892795fed.svg";
export { ForwardRef as ReactComponent };